// extracted by mini-css-extract-plugin
module.exports = {"panel":"LayersControllersCollapse_panel___zavw","panelTitle":"LayersControllersCollapse_panelTitle__fHIS3"};